/**
 * Created by aaguilar
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('documentTypeService', documentTypeService);

    documentTypeService.$inject = ['$http', 'CONFIG', 'messageService'];


    function documentTypeService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/document-types';

        var service = {
            getDocumentTypes: getDocumentTypes,
            getDocumentTypeAndMeasureUnit: getDocumentTypeAndMeasureUnit
        };

        return service;

        function getDocumentTypes(){
            return $http.get(urlBase + "/list")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getDocumentTypeAndMeasureUnit(){
            return $http.get(urlBase + "/document-type-and-measure-unit")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

    }
})();
